import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { Button, Tooltip } from 'antd';
import commonSelector, { viewersBrowserTabFeatureSelector } from '@store/common/selectors';
import { dashboardsSelector } from '@store/tempDashboard/selectors';
import featureNames from '@utils/featureToggle/constants';
import {
  getViewerModuleTempDashboardUrl,
  getViewerModuleNewTabUrl,
} from '@components/common/Dashboard/utils/getTempDashboardUrl';
import { createTempDashboard } from '@store/tempDashboard/actions';
import {
  DASHBOARD_TYPE,
  INTERNAL_UNKNOWN,
  INTERNAL_UNKNOWN_TOOLTIP,
  UNKNOWN,
  UNKNOWN_TOOLTIP,
} from '@utils/constants';
import { QuestionCircleOutlined } from '@ant-design/icons';
import Actions from './Actions';
import { CellContentWrapper } from './styled';
interface IProps {
  data: string | number;
}

const ViewerIdRender = styled(Button)`
  && {
    margin: 0;
    padding-left: 0;
  }
`;

const RenderViewerId = ({ data }: IProps) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { features } = useSelector(commonSelector);
  const isPulse5VMEnabled = features[featureNames.VIEWER_MODULE_PULSE5];
  const dashboards = useSelector(dashboardsSelector);
  const vmBrowserTabEnabled = useSelector(viewersBrowserTabFeatureSelector);
  const keys = Object.keys(dashboards).filter((key) => /^[0-9]*$/.test(key));

  const handleSearch: any = () => {
    if (data) {
      // callback to push new temp tab url
      const redirectHandler = ({ id }) => {
        history.push(getViewerModuleTempDashboardUrl(data, id));
      };

      // create local storage entry
      dispatch(
        createTempDashboard(DASHBOARD_TYPE.VIEWER_MODULE, { viewerId: data }, `Viewer - ${data}`, {
          redirectHandler,
        }),
      );
    }
  };

  const navigateToViewer = React.useCallback(() => {
    if (isPulse5VMEnabled) {
      handleSearch();
    } else {
      const { protocol, host } = window.top.location;
      const url = window.__POWERED_BY_QIANKUN__
        ? `${protocol}//${host}/app/pulse/subscribers/`
        : `${protocol}//${host}/subscribers/`;

      window.open(`${url}?viewerId=${data}&days=1`, '_blank');
    }
  }, [data]);

  let title = '';
  if (data === INTERNAL_UNKNOWN) {
    title = INTERNAL_UNKNOWN_TOOLTIP;
  }
  if (data === UNKNOWN) {
    title = UNKNOWN_TOOLTIP;
  }

  return (
    <CellContentWrapper>
      <div style={{ display: 'inline-block' }}>
        <Tooltip title="Click to see Viewer Details">
          {vmBrowserTabEnabled ? (
            <a
              style={{ color: '#1890ff', textDecoration: 'none' }}
              href={getViewerModuleNewTabUrl(data)}
              target="_blank"
              rel="noopener noreferrer"
            >
              {data}
            </a>
          ) : (
            <ViewerIdRender onClick={navigateToViewer} type="link">
              {data}
            </ViewerIdRender>
          )}
        </Tooltip>
        {title && (
          <Tooltip title={title}>
            <QuestionCircleOutlined style={{ marginLeft: '3px' }} />
          </Tooltip>
        )}
      </div>
      <Actions data={data} />
    </CellContentWrapper>
  );
};

export default RenderViewerId;
